import axios from 'axios';
import getConfig from 'next/config';
import { useState, useEffect } from 'react';
import { AuthContext } from './AuthContext.js';

const { publicRuntimeConfig } = getConfig();

export function AuthProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(function() {
    let canceller = axios.CancelToken.source();

    axios
      .get(`${publicRuntimeConfig.backstageUri}/api/me`, {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
        cancelToken: canceller.token,
      })
      .then(data => {
        setUser(data.data);
      })
      .catch(error => {
        if (
          axios.isCancel(error) ||
          (error.response && error.response.status === 401)
        ) {
          return;
        }

        throw error;
      })
      .finally(() => setIsLoading(false));

    return () => {
      canceller.cancel();
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isLoading,
        user,
        isSignedIn: user !== null,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
